import React from 'react';

const AgentSearchRouteNavigationOptions = {
  headerShown: false
};

export default AgentSearchRouteNavigationOptions; 